{
  "greetings": "Greetings rebel,",
  "TellUs": "Tell us a little about yourself",
  "WhatCity": "What city do you live in?",
  "aboutRebelBase": "RebelBase was born and raised in New York City.",
  "SearchCity": "Search for your city here",
  "purpose": "What is your purpose here?",
  "ReadyButton": "READY!",
  "*required": "*required",
  "WayFindTitle": "Choose Your Own Adventure",
  "WayFindPhrase": "Ready to take control of that great idea you have? Scale up with step-by-step modules that sharpen your skills and jump-start your venture.",
  "CreateProject": "Create a project.",
  "WayFindPhrase2": "Is your team already on RebelBase? Ask them to invite you to the project.",
  "WayFindPhrase3": "The Base is a busy place — explore all the ventures + innovations currently being built and supported by Rebels, just like you.",
  "BrowseProjects": "Browse Projects.",
  "WayFindPhrase4": "Need a space to collaborate, connect and compete? Invite your innovators and form a thriving community, right here.",
  "ContactUsToRequestHubInvite": "Contact us to request a Hub Invite.",
  "WayFindThankYou": "I will find my own way, thank you very much."
}
